module.exports = __webpack_public_path__ + "img/20200427144519582.faef6054.png";